import React, { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as Sentry from '@sentry/react';

const WasteManagementInput = () => {
    const { apiFetch } = useAuth();
    const [percentRecycled, setPercentRecycled] = useState('');
    const [percentDisposed, setPercentDisposed] = useState('');
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        const fetchStats = async () => {
            setLoading(true);
            try {
                const response = await apiFetch('/api/Ops/waste-management-stats');
                const data = await response.json();
                if (data && typeof data.percentRecycled === 'number' && typeof data.percentDisposed === 'number') {
                    setPercentRecycled(data.percentRecycled);
                    setPercentDisposed(data.percentDisposed);
                }
            } catch (catchError) {
                Sentry.captureException(catchError);
                toast.error('Failed to load waste management stats');
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, [apiFetch]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                percentRecycled: Number(percentRecycled) || 0,
                percentDisposed: Number(percentDisposed) || 0
            };
            const response = await apiFetch('/api/Ops/waste-management-stats', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                toast.success('Waste management stats saved!');
            } else {
                toast.error('Save failed');
            }
        } catch (catchError) {
            Sentry.captureException(catchError);
            toast.error('Save failed');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={{ maxWidth: 400, margin: '0 auto', padding: 24 }}>
            <h2>Waste Management Input</h2>
            {loading ? (
                <div>Loading...</div>
            ) : (
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        handleSave();
                    }}
                >
                    <div style={{ marginBottom: 16 }}>
                        <label htmlFor="percentRecycled">Percent Recycled (%)</label>
                        <input
                            id="percentRecycled"
                            type="number"
                            min="0"
                            max="100"
                            value={percentRecycled}
                            onChange={e => setPercentRecycled(e.target.value)}
                            style={{ width: '100%', padding: 8, marginTop: 4 }}
                            required
                        />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <label htmlFor="percentDisposed">Percent Disposed (%)</label>
                        <input
                            id="percentDisposed"
                            type="number"
                            min="0"
                            max="100"
                            value={percentDisposed}
                            onChange={e => setPercentDisposed(e.target.value)}
                            style={{ width: '100%', padding: 8, marginTop: 4 }}
                            required
                        />
                    </div>
                    <button type="submit" disabled={saving}>
                        {saving ? 'Saving...' : 'Save'}
                    </button>
                </form>
            )}

        </div>
    );
};

export default WasteManagementInput;